addEventListener("depictProductCardRendered", async ({ detail }) => {
  const { element, product } = detail;
  const { handle, variant_id: variantId } = product;

  if (!handle || !variantId) return;

  const priceContainer = element.querySelector(".d-price-container");
  const textContainer = element.querySelector(".d-product-text");
  if (!priceContainer || !textContainer) return;

  // Add loading placeholder while fetching price
  const loadingDisplay = document.createElement("span");
  loadingDisplay.className =
    "aria-busy:animate-pulse aria-bust:opacity-70 w-1/2 bg-ce-cool mb-2 h-4 block";
  loadingDisplay.setAttribute("aria-busy", "true");
  textContainer.appendChild(loadingDisplay);

  priceContainer.style.display = "none";

  try {
    const response = await fetch(
      `/products/${handle}/?variant=${variantId}&section_id=meta-variant-price`
    );
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, "text/html");

    const discountEl = doc.querySelector(`#variant-discount-${variantId}`);
    if (!discountEl) return;

    priceContainer.replaceWith(discountEl);
  } finally {
    loadingDisplay.remove();
  }
});